import { RootState } from 'app/store'
import { ISnackbar } from './snackbarSlice'

export const selectSnackbar = (state: RootState): ISnackbar | undefined =>
  state.snackbar
